<template>
    <div class="details">
        <div class="header">
            <cl-page-back icon="page_back_white" @click="backFun">
                <div class="title">{{ detailsData.name }}</div>
            </cl-page-back>
            <div class="article_info">
                <span class="article_info_item mr24">
                    <cl-svg-icon
                        class="mr3"
                        icon-class="tu_schedule_date"
                        width="18"
                        :currentColor="false"
                    ></cl-svg-icon>
                    <i class="AkrobatR">
                        {{ detailsData.start_date }} - {{ detailsData.end_date }}
                    </i>
                </span>
                <span class="article_info_item mr10">
                    <cl-svg-icon
                        class="mr3"
                        icon-class="tu_schedule_pitch"
                        width="18"
                        :currentColor="false"
                    ></cl-svg-icon>
                    <i style="font-size:14px">
                        {{ detailsData.pitch }}
                    </i>
                </span>
            </div>
            <cl-tabs
                class="pl24"
                v-if="tabList.length"
                :options="tabList"
                v-model="activeTab"
                active-bg-color="#ffffff"
                defaultBgColor="#FBFBFB"
                defaultColor="#B7B7BF"
            >
            </cl-tabs>
        </div>
        <div class="main" v-if="detailsData" :style="{'padding-top': activeTab === 'contents' ? '16px' : '4px'}">
            <contentsView v-if="activeTab === 'contents'" :detailsData="detailsData" />
            <workAge v-if="activeTab === 'workAge'" :detailsData="detailsData" />
            <teamsView v-if="activeTab === 'teams'" :detailsData="detailsData" />
            <selectionView v-if="activeTab === 'selection'" :detailsData="detailsData" />
            <staffsView v-if="activeTab === 'staff'" :detailsData="detailsData" />
            <videoView v-if="activeTab === 'video'" :detailsData="detailsData" />
        </div>
    </div>
</template>

<script>
import contentsView from './components/contentsView.vue'
import workAge from './components/workAge.vue'
import teamsView from './components/teamsView.vue'
import staffsView from './components/staffsView.vue'
import selectionView from './components/selectionView.vue'
import videoView from './components/videoView.vue'
export default {
    components: {
        contentsView,
        workAge,
        teamsView,
        staffsView,
        videoView,
        selectionView
    },
    data() {
        return {
            activeTab: 'contents',
            tabList: [
                { title: 'camp.内容', key: 'contents' },
                { title: 'camp.工作安排', key: 'workAge' },
                { title: 'report.梯队', key: 'teams' },
                { title: 'camp.选材组', key: 'selection' },
                { title: 'schedule.教练组', key: 'staff' },
                { title: 'ts.视频', key: 'video' },
            ],
            detailsData: {}, // 详情数据
            id: '',
            tenantId: '',
        }
    },

    methods: {
        backFun() {
            this.$router.go(-1)
        },
        async getData() {
            const params = {
                tenant_id: this.tenantId,
            }
            const { code, data } = await this.$server.getTriainingCamp(params, this.id)
            if (code === 200) {
                this.detailsData = data
                this.detailsData.tenant_id = this.tenantId
            }
        },
    },
    created() {
        this.id = this.$route.query.id
        this.tenantId = this.$route.query.tenantId
        this.getData()
    },
}
</script>
<style lang="scss" scoped>
.details {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    .header {
        padding-top: 18px;
        padding-left: 34px;
        width: 100%;
        background: url("~@i/cfa/header_bg.png") center center no-repeat;
        background-size: 100% 100%;
        .title {
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 500;
            font-size: 30px;
            line-height: 42px;
            color: #fff;
        }
        .article_info {
            margin-top: 7px;
            margin-bottom: 24px;
            .article_info_item {
                font-weight: 400;
                font-size: 16px;
                line-height: 19px;
                color: rgba(255, 255, 255, 1);
                i {
                    font-style: normal;
                    color: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }
    .main {
        flex: 1;
        overflow: hidden;
        padding: 0 24px 24px;
        box-sizing: border-box;
        &.report{
            padding:14px 24px 0;
        }
    }
}
</style>
